import { getToken } from '@efsa/dlw-authenticator';
import fetch from 'isomorphic-fetch';

export default async function callApi({ endpoint, options = {} }) {
  const defaultOptions = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'not-store, no-cache',
      Pragma: 'no-cache',
      Expires: 0,
    },
    credentials: 'same-origin',
    cache: 'no-cache',
  };

  // If no token is present, force login
  const token = await getToken();

  if (token.length) {
    defaultOptions.headers.Authorization = `Bearer ${token}`;
  }

  if (options.contentType) {
    defaultOptions.headers['content-type'] = options.contentType;
  }

  if (options.formData) {
    delete defaultOptions.headers['content-type'];
  }

  if (options.method === 'PUT' || options.method === 'POST') {
    if (!options.data) {
      throw new Error(
        'The data attribute is required when doing a put or post'
      );
    }
    if (options.formData) {
      options.body = options.data; // eslint-disable-line no-param-reassign
    } else {
      options.body = JSON.stringify(options.data); // eslint-disable-line no-param-reassign
    }
  }

  const getUrl = () => {
    return `/api/${endpoint}`;
  };

  function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }
    if (!response.ok) {
      let errorMessage = `${
        options.errorMessage ? `${options.errorMessage}: ` : ''
      }${response.statusText}`;
      if (response.status === 401) {
        errorMessage = '';
      }

      const errorObject = {
        error: true,
        status: response.status,
        statusText: response.statusText,
        message: errorMessage,
        silent: options.silent,
      };
      return response.json().then(
        (res) =>
          Promise.reject({
            ...errorObject,
            response: res,
            message: `${
              options.errorMessage ? `${options.errorMessage}: ` : ''
            }${res.Message || response.statusText}`,
          }),
        () => Promise.reject(errorObject)
      );
    }
    return response.json().then((err) => Promise.reject(err));
  }
  return fetch(getUrl(), { ...defaultOptions, ...options })
    .then((res) => checkStatus(res))
    .then((res) => {
      if (res.headers.get('content-type')) {
        if (res.headers.get('content-type') === 'application/octet-stream') {
          // eslint-disable-next-line no-param-reassign
          delete res.headers;
        }

        return res.json().then((results) => ({
          data: results.data,
        }));
      }
      return res;
    })
    .catch((err) => Promise.reject(err));
}
